import { render, staticRenderFns } from "./Factors.vue?vue&type=template&id=4b00a4b5&scoped=true&"
import script from "./Factors.vue?vue&type=script&lang=js&"
export * from "./Factors.vue?vue&type=script&lang=js&"
import style0 from "./Factors.vue?vue&type=style&index=0&id=4b00a4b5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b00a4b5",
  null
  
)

export default component.exports